import { Tag } from "components/DesignSystem/Tag/Tag";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useGetBookkeepingSettingsQuery } from "store/apis/booksLockDate";
import { AccountCardsSection, TabEmptyState } from "../DataSourcesList";
import { GustoCard } from "../Gusto/GustoCard";

export const Payroll = ({
  groupId,
  onOpenConnectionModal,
  onOpenSubscriptionModal,
}: {
  groupId: string;
  onOpenConnectionModal: () => void;
  onOpenSubscriptionModal: () => void;
}) => {
  const entityId = useCurrentEntityId();

  const { data: bookkeepingSettings } = useGetBookkeepingSettingsQuery(
    {
      entityId: entityId!,
    },
    { skip: !groupId || !entityId }
  );

  return (
    <div className="t-overflow-y-auto t-py-3 t-px-2.5">
      {bookkeepingSettings?.gusto_access ? (
        <AccountCardsSection>
          <GustoCard
            name="Gusto"
            description="Access Shared"
            tag={
              <Tag size="small" rounded icon={false} tagType="light_grey">
                Manually added
              </Tag>
            }
          />
        </AccountCardsSection>
      ) : (
        <TabEmptyState
          title="No payroll sources added"
          description="Connect your Gusto account to enable one-click import of your payroll data for accurate accounting"
          onOpenConnectionModal={onOpenConnectionModal}
          onOpenSubscriptionModal={onOpenSubscriptionModal}
        />
      )}
    </div>
  );
};
